<div id="reportAllDonations" style="display:none;margin-top: 3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="row custom-material-form updated-dropdown">
            <div class="col">
                <div class="md-form">
                    <input placeholder="Start date" type="text" id="allDonationsStartDate" class="form-control datepicker" style="cursor: pointer;">
                    <label id="allDonationsStartDateLabel" for="allDonationsStartDate">Start Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('allDonationsStartDate').focus()" style="cursor:pointer"></i>
                </div>
            </div>
            <div class="col">
                <div class="md-form">
                    <input placeholder="End date" type="text" id="allDonationsEndDate" class="form-control datepicker" style="cursor: pointer;">
                    <label id="allDonationsEndDateLabel" for="allDonationsEndDate">End Date</label>
                    <i class="far fa-calendar-alt calendar-icon--paybee" onclick="document.getElementById('allDonationsEndDate').focus()" style="cursor:pointer"></i>
                </div>
            </div>
        </div>
        <div class="row" style="margin-bottom: 1.5rem">
            <div class="col">
                <div class="card chart-card">
                    <div class="classic-tabs">
                        <ul class="nav tabs-white nav-fill" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link waves-light active" data-toggle="tab" href="#panelSummary" role="tab">Summary</a>
                            </li>
                            <li class="nav-item ml-0">
                                <a class="nav-link waves-light" data-toggle="tab" href="#paneFilters" role="tab">Report Filters</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link waves-light" data-toggle="tab" href="#panelColumns" role="tab">Select Columns</a>
                            </li>
                        </ul>
    
                        <div class="tab-content rounded-bottom pb-5">
                            <div class="tab-pane fade in show active" id="panelSummary" role="tabpanel">
                                <div class="row text-center allDonationSummaryRow">
                                    <div class="col">
                                        <div class="row">
                                            <div class="col allDonationSummary">
                                                <span>Pledges</span><br>
                                                <span id="allDonationSummaryPledged">$0</span>
                                            </div>
                                            <div class="col allDonationSummary">
                                                <span>Donations</span><br>
                                                <span id="allDonationSummaryDonated">$0</span>
                                            </div>
                                            <div class="col allDonationSummary" style="border: none">
                                                <span>Card</span><br>
                                                <span id="allDonationSummaryCard">$0</span>
                                            </div>
                                        </div>
                                        <hr style="width: 50%">
                                        <div class="row">
                                            <div class="col allDonationSummary">
                                                <span>Bank Account</span><br>
                                                <span id="allDonationSummaryBank">$0</span>
                                            </div>
                                            <div class="col allDonationSummary">
                                                <span>Check</span><br>
                                                <span id="allDonationSummaryCheck">$0</span>
                                            </div>
                                            <div class="col allDonationSummary" style="border: none">
                                                <span>Cash</span><br>
                                                <span id="allDonationSummaryCash">$0</span>
                                            </div>
                                        </div>
                                        <hr style="width: 50%">
                                        <div class="row justify-content-center">
                                            <div class="col">
                                                <div class="container-fluid text-center">
                                                    <div class="row">
                                                        <div class="col mb-md-0 mb-3">
                                                            <a href="#!" id="allDonationsMtd" class="btn btn-xs waves-effect">MTD</a>
                                                            <a href="#!" id="allDonationsYtd" class="btn btn-xs waves-effect">YTD</a>
                                                            <a href="#!" id="allDonationsLastMonth" class="btn btn-xs waves-effect">Last Month</a>
                                                            <a href="#!" id="allDonationsLastYear" class="btn btn-xs waves-effect">Last Year</a>
                                                            <a href="#!" id="allDonationsDateCustom" class="btn btn-xs waves-effect">Custom</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="row">
                                            <div class="col" id="summaryChartCol">
                                                <canvas id="summaryLineChart" style="width: 400px;"></canvas>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade custom-material-form updated-dropdown" id="paneFilters" role="tabpanel">
                                <div class="row">
                                    <div class="col">
                                        <div class="container-fluid text-center text-md-left">
                                            <div class="row">
                                                <div class="col mb-md-0 mb-3">
                                                    <span id="savedReportButtons">
                                                    </span>
                                                </div>
                                                <div class="col text-right">
                                                    <a href="#!" id="saveCurrentReport" class="btn btn-sm waves-effect btn-info"><i class="fas fa-save"></i>&nbsp;&nbsp;Save Report</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row justify-content-center">
                                    <div class="col-md-8 col-sm-12 mb-4">
                                        <div class="text-left" style="color: #757575; font-size: 0.8rem;">Campaigns</div>
                                        <fieldset class="form-group  mb-4" id="campaignSelectReportFS">
                                        </fieldset>
                                    </div>
                                </div>
                                <div id="allFilters">
                                    <div class='row'>
                                        
                                        <div class='col' id="allDReportMethodSelectCol">
    
                                        </div>
                                        <div class='col' id="allDReportTypeSelectCol">
                                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">Type</div>
                                        </div>
                                        <div class='col' id="allDReportStatusSelectCol">
                                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">Status</div>
                                        </div>
                                        <div class='col'> 
                                            <div class="text-left" style="color: #757575; font-size: 0.8rem;">Recurring</div>
                                            <select id='allDReportRecurringSelect' class='select-wrapper mdb-select mdb-select--paybee'>
                                                <option value='0' selected>All</option>
                                                <option value='1'>Recurring</option>
                                                <option value='2'>OneTime</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="panelColumns" role="tabpanel">
                                <div class="row" style="font-size: small;">
                                    <div class="col" id="selectColumns">
                                    </div>
                                </div>
                                <div class="row justify-content-right">
                                    <div class="col">
                                        <div class="container-fluid text-right">
                                            <div class="row">
                                                <div class="col mb-md-0 mb-3">
                                                    <a href="#!" id="columnSelectApply" class="btn btn-xs waves-effect">Apply</a>
                                                    <a href="#!" id="columnSelectReset" class="btn btn-xs waves-effect">Reset</a>
                                                    <a href="#!" id="columnSelectAll" class="btn btn-xs waves-effect">select All</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table--paybee">
            <div class='text-center no-data-text' style="display: none" id="emptyAllDonationsList">No transaction match this criteria.</div>
            <table id ="allDonationsList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr id="allDonationsHeader">
                </tr>
                </thead>
            </table>
        </div>
    </div>
</div>